export function getUrlParamsAsString() {
  return new URLSearchParams(window.location.search).toString();
}
